import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../routes.js";

export function NotFoundScreen(): React.ReactElement {
  return (
    <div
      data-testid="not-found-screen"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
      }}
    >
      <h2 style={{ fontSize: "20px", marginBottom: "8px" }}>Страница не найдена</h2>
      <p style={{ color: "var(--color-slate)", marginBottom: "24px" }}>
        Запрашиваемая страница не существует.
      </p>
      <Link
        to={ROUTES.MAIN}
        style={{
          padding: "12px 24px",
          backgroundColor: "var(--color-muted-gold)",
          color: "var(--color-paper)",
          borderRadius: "var(--radius-button)",
          textDecoration: "none",
          fontWeight: 600,
        }}
      >
        На главную
      </Link>
    </div>
  );
}
export default NotFoundScreen;
